import axios from 'axios';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/esm/Container';
import { Link, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Loader from '../../Components/Loader/Loader';
import { Constants } from '../../Utils/Constants';
import './RateAdmin.scss';

import PercentageSymbol from '../../Components/PercentageSymbol';
import RupeeSymbol from '../../Components/RupeeSymbol';
import { showErrorNotification, showInfoNotification } from '../../Services/Notifications';
import { headers } from '../../Utils/utils';
import EditRateTable from './EditRatesComponent';

const products = {

  cn: 'Currency Notes',
  fc: 'Forex Card',
  tt: 'Telegraphic Transfer',
};

const Companies = {
  1: 'RemitX',
  2: 'Yes Germany',
  3: 'Uni Cred',
};

const marginLimit =process.env.REACT_APP_MARGIN_LIMIT_PAISE || 10;
// const marginLimitPer=process.env.REACT_APP_MARGIN_LIMIT_PERCENTAGE || 20;

const getMarginLimitPer = (product) => {
  if (product === 'fc') return 40;
  return 20;
};

let colNames = [
  'cust. Buy Margin',
  'Holiday Buy Margin',
  'cust. Sell Margin',
  'Holiday Sell Margin'
];

const startTime = '09:30';

const endTime = '14:30';


const showUserName = (name) => {
  name = name.split(' ')[0];
  if (name.length < 9) return name;
  else return `${name.slice(0, 7)}..`;
};

const fetchBranchData = async (branchId = null, productName, clientId) => {
  let postData;

  if (branchId) {
    postData = {
      branchId: branchId,
      productName: productName,
      clientId: clientId,
    };
  } else {
    return;
  }
  try {
    let header = headers();
    let data = await axios.post(Constants.BACKEND_API_URL + 'services/rateadmin/branchdata', postData, {headers: header});
    return data;
  } catch (e) {

    return e;
  }
};

async function makeCallToFetchData(branchId, product, clientId) {
  // //console.log("....", currentBranch?.BranchID || branchId, product);
  let data = await fetchBranchData(branchId, product, clientId);
  if (!data) return [];
  return [...data.data.data];
}

const RateAdmin = ({ userRole,userCode,userPermission }) => {

  const [showLoader, setShowLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showAddNewModal, setShowAddNewModal] = useState(false);

  const [branches, setBranches] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [searchBranchText, setSearchBranchText] = useState('');
  const [product, setProduct] = useState(Object.keys(products)[0]);
  const [companyValue, setCompanyValue] = useState('1');
  const [usertype,setUsertype]=useState('');
  const fileInputRef = useRef();

  const [currentBranch, setCurrentBranch] = useState(null);
  const [currentBranchData, setCurrentBranchData] = useState([]);
  //   const [allCurrencies, setAllCurrencies] = useState([]);

  const [selectedValue, setSelectedValue] = useState('Paise'); // Initialize with a default value
  const [excelData, setExcelData] = useState(null);
  const [isUsingExcel, setIsUsingExcel] = useState(false);
  const [allCurrencies, setAllCurrency] = useState([]);
  const [selectedBranches, setSlectedBranches] = useState([]);
  const [multiplebrancharray, setMultipleBranchArray] = useState([]);
  const [branchNamesOptions, setBranchNamesOptions] = useState([]);
  const [allCurrencyCodes, setAllCurrencyCodes] = useState([]);
  const [tempBranchId, setTempBranchId] = useState({});
  const [holidays, setHolidays] =useState([]);
  const navigate = useNavigate();
  const handleShow = (branchData) => {
    setTempBranchId(branchData);
    setShow(true);
  };

  const [selectionLimit, setSelectionLimit] = useState(-1);
  const [currencyIbrMap, setcurrencyIbrMap] = useState({});
  const handleClose = () => { fileInputRef.current.value=null;  setShow(false) };

  const getHolidays = async () => {
    try {
      let url = Constants.REMITX_NODE_API_URL;
      let endpoint = url + 'api/holidays-list';
      let holidaysList = await axios.get(endpoint);
      holidaysList = Object.values(holidaysList.data.data);
      setHolidays(holidaysList);
    } catch(e) {
      console.log(e);
      showErrorNotification("Please refresh the page or try  after some time.");
    }
  }

  function isNotHolidayTime(startTime, endTime) {
    try {
        const format = "HH:mm";
        let beginningTime = moment(startTime, format);
        let endingTime = moment(endTime, format);
        let currentTime = moment();
        // console.log(beginningTime, endTime, currentTime)
        if (currentTime.isBefore(beginningTime))  return false;
        if (currentTime.isAfter(endingTime)) return false;
        let dow = currentTime.day();
        let holidayDow = [0, 6]; //0 - sunday, 6 - saturday
        if (holidayDow.includes(dow)) return false;
        
        let checkHoliday = holidays.find(item => {
            let holidayDate = moment(item.HolidayDate, "YYYY-MM-DD");
            if (holidayDate.isSame(currentTime.format("YYYY-MM-DD"))) return true; 
        })
        if (checkHoliday) return false;
        return true;
    } catch(e) {
        console.log(e);
        return "";
    }
  }
  
  let calcFinalRatePaise = (ibr, custMargin, holidayMargin, type,ibrCode) => {
    let isWorkingTime = isNotHolidayTime(startTime, endTime);
    if (isWorkingTime) holidayMargin = 0;

    let placesToShow=2;
    if(Constants.IBRCODES_FIVE_DECIMAL.includes(ibrCode))
    placesToShow=5;
     
    if (type === 'buy') return (ibr * 1 + custMargin * 1 + holidayMargin * 1).toFixed(placesToShow);
    else return (ibr * 1 - custMargin * 1 - holidayMargin * 1).toFixed(placesToShow);
  };
  
  let calcFinalRatePerc = (ibr, custMargin, holidayMargin, type,ibrCode) => {


    let isWorkingTime = isNotHolidayTime(startTime, endTime);
    if (isWorkingTime) holidayMargin = 0;
  
    ibr = ibr * 1;
    custMargin = custMargin * 1;
    holidayMargin = holidayMargin * 1;

    let placesToShow=2;
    if(Constants.IBRCODES_FIVE_DECIMAL.includes(ibrCode))
    placesToShow=5;

    if (type === 'buy') return (ibr + (ibr * custMargin) / 100 + (ibr * holidayMargin) / 100).toFixed(placesToShow);
    else return (ibr - (ibr * custMargin) / 100 - (ibr * holidayMargin) / 100).toFixed(placesToShow);
  };

  useEffect(() => {
    getHolidays();
  }, []);

  useEffect(() => {

    setUsertype(userRole);
    if (searchBranchText) {
      let filteredBranch = allBranches.filter(
        (item) =>
          item?.BranchName?.toLowerCase()?.includes(searchBranchText) || item?.BranchCode?.toLowerCase()?.includes(searchBranchText),
      );
      setBranches(filteredBranch);
    } else {
      setBranches(allBranches);
    }
  }, [searchBranchText, userRole]);

  // Event handler to update the selectedValue state
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const branchChangeEvent = (branch) => {
    if (currentBranch?.BranchID === branch.BranchID) return;
    else {
      setCurrentBranch(branch);
    }
  };

  const handleImportExcel = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0]; // Assuming the first sheet is the one you want to read
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to an array of arrays
      const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setIsUsingExcel(true);

      let exldata = [];
      for (let i = 1; i < excelData.length; i++) {
        let obj = {
          code: excelData[i][0],
          ibr: currencyIbrMap[excelData[i][0]],
          buy_margin: excelData[i][1],
          sell_margin: excelData[i][3],
          holiday_buy_margin: excelData[i][2],
          holiday_sell_margin: excelData[i][4],
        };

        // let limit=selectedValue==='Paise'?marginLimit:marginLimitPer

        let limit = selectedValue === 'Paise'
  ? marginLimit
  : getMarginLimitPer(product);

       if(obj.buy_margin>limit||obj.sell_margin>limit||obj.holiday_buy_margin>limit||obj.holiday_sell_margin>limit){
        // showInfoNotification(`Margin upto INR ${marginLimit}/- is allowed only`);
        showInfoNotification(
          selectedValue === 'Paise'
            ? `Margin upto INR ${marginLimit}/- is allowed only`
            : `Margin upto ${getMarginLimitPer(product)}% is allowed only`
        );
        setExcelData(null);
        setIsUsingExcel(false);
        fileInputRef.current.value = null;
        return;

       }
        if (!allCurrencyCodes.includes(obj.code)) {
          showInfoNotification('Some Currency Code in Excel is not Valid');
          setExcelData(null);
          setIsUsingExcel(false);
          fileInputRef.current.value = null;
          return;
        }

        if (
          typeof obj.buy_margin != 'number' ||
          typeof obj.sell_margin != 'number' ||
          typeof obj.holiday_buy_margin != 'number' ||
          typeof obj.holiday_sell_margin != 'number'
        ) {

          showInfoNotification('Only Numeric Values are allowed ');
          setExcelData(null);
          setIsUsingExcel(false);
          fileInputRef.current.value = null;
          return;
        }

        showInfoNotification('Excel File Imported Successfully');
        exldata.push(obj);
      }

      setExcelData(exldata);
     
    };

    reader.readAsBinaryString(file);
  };

  const handleDownloadClick = async (branchId) => {
    // Fetch Data Corresponding to Brnchcode
    try {
      setShowLoader(true)
      let data = await fetchBranchData(branchId, product, companyValue);

      downloadExcel(data.data.data);
    } catch (e) { }
    finally {
      setShowLoader(false)
    }
  };

  const downloadExcel = (branchData, isMultiple = false) => {

    let data = [];
    let colheader;
    if (!isMultiple)
      colheader = ['Currency', ...colNames, 'Branch Name'];
    else colheader = ['Currency', ...colNames];

    data.push(colheader);

    branchData.map((currentData) => {
      let d = [
        currentData.code,
        currentData.buy_margin || 0,
        currentData.holiday_buy_margin || 0,
        currentData.sell_margin || 0,
        currentData.holiday_sell_margin || 0,
        currentData.branchName,
      ];
      data.push(d);
    });
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Create a new worksheet and add the data
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a blob from the workbook
    if (!isMultiple)
      XLSX.writeFile(workbook, `${(branchData[0]?.branchName) ? branchData[0]?.branchName + "-" : ""}${product.toUpperCase()}-${Companies[companyValue]}.xlsx`);
    else XLSX.writeFile(workbook, `Sample.xlsx`);
    showInfoNotification('Excel File Downloaded');
  };
  // Initially Fetching all the branches and currencies
  useEffect(() => {

    async function fetchBranches() {
      try {
        setShowLoader(true)
        let header = headers();
        const branchData = await axios.get(
          Constants.BACKEND_API_URL + 'services/rateadmin/getBranches?client_id=' + companyValue + '&product=' + product,
          { headers: header },
        );
        if (branchData?.data?.responseCode === 400) {
          showInfoNotification("No permission associated with your id.");
          return navigate('/');
        }
        // //console.log(".#####..", JSON.stringify(branchData));
        let branches = branchData.data.data;
        //console.log(branches);

        if (tempBranchId?.BranchID) setCurrentBranch(tempBranchId);
        else setCurrentBranch(branches[0]);

        // setCurrentBranchData(branchCurrencyRateData);
        setBranches(branches);
        setAllBranches(branches);
        insertBranchOptions(branches);
      } catch (e) {
        showErrorNotification("Some Error Occured, try later.")

        console.log(e);
      } finally {
        setShowLoader(false)
      }
    }

    async function fetchCurrencies() {
      try {
        setShowLoader(true)
        let currencies = await axios.get(Constants.BACKEND_API_URL + 'services/rateadmin/currencies');

        let allcurrencies = currencies.data.data;
        setAllCurrency(allcurrencies);
        PopulateMultipleBranchArray(allcurrencies);
      } catch (e) {

        showErrorNotification("Some Error Occured, try later.")
        console.log(e);
      }
      finally {

        setShowLoader(false)

      }
    }

    fetchCurrencies();
    if ((!show && !showAddNewModal) || companyValue)
      fetchBranches();



  }, [show, showAddNewModal, companyValue, product]);

  const insertBranchOptions = (branches) => {
    let branchoptions = [];

    // //console.log('branches inside insertBranchOptions');
    // //console.log(branches);

    let ob = {
      name: 'Select All Branches',
      id: 'Select All Branches',
    };

    branchoptions.push(ob);

    branches.map((branch) => {
      let obj = {
        name: branch.BranchName,
        id: branch.BranchID,
      };

      branchoptions.push(obj);
    });

    setBranchNamesOptions(branchoptions);
  };

  const downloadAllBranchData = async () => {
    let data = await fetchBranchData(null, product);

   
    let allData = data.data.data;

    downloadExcel(allData);
  };

  // When Branche is changed
  useEffect(() => {

    async function getBranchCurrencyData() {
      try {
        setShowLoader(true)
        let branchCurrencyRateData = await makeCallToFetchData(currentBranch.BranchID, product, companyValue);
        setCurrentBranchData(branchCurrencyRateData);

      

      } catch (e) {
        showErrorNotification("Some Error Occured, try later.")
        console.log(e);

      } finally {
        setShowLoader(false)
      }
    }
    if (currentBranch && !show && !showAddNewModal) {
      getBranchCurrencyData();
    }
    // //console.log(".....")
  }, [currentBranch, show, showAddNewModal, companyValue]);

  useEffect(() => {

    async function getBranchCurrencyData() {
      try {
        setShowLoader(true)
        let branchCurrencyRateData = await makeCallToFetchData(tempBranchId?.BranchID, product, companyValue);
        setCurrentBranchData(branchCurrencyRateData);
      } catch (e) {
        showErrorNotification("Some Error Occured, try later.")
        console.log(e)

      } finally {
        setShowLoader(false)
      }
    }
    getBranchCurrencyData();

  }, [show]);

  // Populating Multiple Branch Array
  const PopulateMultipleBranchArray = (currencies) => {
    let d = [];
    let mymap = {};

    currencies?.map((currency) => {
      setAllCurrencyCodes((pre) => {
        return [...pre, currency.code];
      });

      mymap[currency.code] = currency.ask;

      let obj = {
        currency_code: currency.code,
        ask: currency.ask,

        buy_margin: 0,
        sell_margin: 0,
        holiday_buy_margin: 0,
        holiday_sell_margin: 0,
      };
      d.push(obj);
    });

    setcurrencyIbrMap(mymap);


    setMultipleBranchArray(d);
  };

  const handleSaveClicked = async () => {
    setShowLoader(true);
    let datatosend = {
      branchId: tempBranchId?.BranchID || currentBranch.BranchID,
      calculation_type: selectedValue,
      productName: product,
      data: isUsingExcel ? excelData : currentBranchData,
      clientId: companyValue,
    };
    let isValid=validateMargin(datatosend.data)
    if(!isValid)
    return;

    await axios
      .post(Constants.BACKEND_API_URL + 'services/rateadmin/addrates/singlebranch', datatosend, { headers: headers() })
      .then((data) => {
      })
      .catch((e) => {
       
        showErrorNotification("Some Error Occured, try later.")
        console.log(e);
      });
    setShowLoader(false);
    setShow(false);
    showInfoNotification('Add/Updation Successfull');
    setIsUsingExcel(false);
    handleClose();
  };


  const handleBranchAdded = (selectedbranches, selectedItem) => {
    if (selectedItem.name === 'Select All Branches') 
      setSelectionLimit(1);
    
    setSlectedBranches(selectedbranches);
  };

  const handleBranchRemoved = (selectedbranches, selectedItem) => {

    if (selectedItem.name === 'Select All Branches')
        setSelectionLimit(-1);
    setSlectedBranches(selectedbranches);
  };

  const validateMargin=(data)=>{
    // let limit=selectedValue==='Paise'?marginLimit:marginLimitPer

    let limit = selectedValue === 'Paise'
  ? marginLimit
  : getMarginLimitPer(product);



    for(let i=0;i<data.length;i++){
      let d=data[i];
      let errMsg="";

      if(d.buy_margin==="" ||d.sell_margin===""||d.holiday_buy_margin===""||d.holiday_sell_margin==="")
     {
      setShowLoader(false);
      showErrorNotification("Kindly input the margin as it can't be left blank");
      return false;
     }

      if(d.buy_margin*1>limit||d.sell_margin*1>limit||d.holiday_buy_margin*1>limit||d.holiday_sell_margin*1>limit)
      {
        setShowLoader(false);
        if(d.buy_margin*1>limit)

        // errMsg=selectedValue=='Paise'?`Customer Buy Margin can't be more than INR ${marginLimit}/-`:`Customer Buy Margin can't be more than ${marginLimitPer}%`
        errMsg=selectedValue=='Paise'?`Customer Buy Margin can't be more than INR ${marginLimit}/-`:`Customer Buy Margin can't be more than ${getMarginLimitPer(product)}%`

        else if(d.sell_margin*1>limit)
          // errMsg=selectedValue=='Paise'?`Customer Sell Margin can't be more than INR ${marginLimit}/-`:`Customer Sell Margin can't be more than ${marginLimitPer}%`
          errMsg=selectedValue=='Paise'?`Customer Sell Margin can't be more than INR ${marginLimit}/-`:`Customer Sell Margin can't be more than ${getMarginLimitPer(product)}%`

          else if(d.holiday_buy_margin*1>limit)
          // errMsg=selectedValue=='Paise'?`Holiday Buy Margin can't be more than INR ${marginLimit}/-`:`Holiday Buy Margin can't be more than ${marginLimitPer}%`
          errMsg=selectedValue=='Paise'?`Holiday Buy Margin can't be more than INR ${marginLimit}/-`:`Holiday Buy Margin can't be more than ${getMarginLimitPer(product)}%`

          else if(d.holiday_sell_margin*1>limit)
          // errMsg=selectedValue=='Paise'?`Holiday Sell Margin can't be more than INR ${marginLimit}/-`:`Holiday Sell Margin can't be more than ${marginLimitPer}%`
          errMsg=selectedValue=='Paise'?`Holiday Sell Margin can't be more than INR ${marginLimit}/-`:`Holiday Sell Margin can't be more than ${getMarginLimitPer(product)}%`
        showErrorNotification(errMsg)
        return false
      }
    }
    return true;
  }

  // Making Request to save Multiple Data
  const saveMultipleBranchData = async () => {
    if (selectedBranches.length == 0) {
      showErrorNotification('No Branch Selected');
      return;
    }
    setShowLoader(true);
    let dataTosend = {
      calculation_type: selectedValue,
      data: isUsingExcel ? excelData : multiplebrancharray,
      selectedBranches: selectionLimit == 1 ? branchNamesOptions.slice(1) : selectedBranches,
      productName: product,
      clientId: companyValue,
    };
    let isValid=validateMargin(dataTosend.data)

    if(!isValid)
    return;

    if(isValid){
    await axios.post(Constants.BACKEND_API_URL + 'services/rateadmin/addrates/singlebranch', dataTosend, { headers: headers() })
      .then((data) => {
    
      })
      .catch((e) => {
        showErrorNotification("Some Error Occured, try later.")
        console.log(e);
      });
    }

    showInfoNotification('Added New Rates');

    setShowLoader(false);
    setShowAddNewModal(false);
    setIsUsingExcel(false);
    setSlectedBranches([]);
    handleClose();
  };

  return (
    <>

      <Container id="RemitxLiveRates">
        {showLoader && <Loader />}
        <Row>
          <Col sm={7}>
            <h1>Manage {Companies[companyValue]} Live Rate</h1>
          </Col>
          <Col sm={3}></Col>
          <Col sm={2} id="SelectPartners">
            <Form.Select className="mrg-t30" defaultValue={companyValue} onChange={(e) => setCompanyValue(e.target.value)}>
              {/* <option>Select Partners</option> */}
              {Object.keys(Companies).map((item) => {
                if( userRole=='admin' ||   userPermission?.includes(  `client_` + Companies[item].toLocaleLowerCase().replace(" ","_") ))
                return <option value={item}>{Companies[item]}</option>;
              })}
            </Form.Select>
          </Col>
        </Row>

        <Tabs
          onSelect={(e) => {
            setProduct(e);
          }}
          defaultActiveKey="cn"
          id="uncontrolled-tab-example"
          className="tab-margin"
        >
          {Object.keys(products).map((item) => {
             return  <Tab eventKey={item} title={products[item]} onChange={() => setProduct(item)}>
              <Tab.Container id="left-tabs-example" activeKey={currentBranch?.BranchName || 'MUMBAI-ANDHERI'}>
                <Row>
                  <Col sm={3}>
                    <div>
                      {allBranches.length > 1 && <input
                        className="form-control mb-3"
                        placeholder="Search Branch Name"
                        value={searchBranchText}
                        onChange={(e) => {
                          setSearchBranchText(e.target.value);
                        }}
                      />}
                    </div>
                    <Nav variant="pills" className="flex-column" id="v-Pills">
                      {branches?.map((branch) => {
                        return (
                          <Nav.Item>
                            <Nav.Link
                              onClick={() => {
                                branchChangeEvent(branch);
                              }}
                              eventKey={branch.BranchName}
                            >
                              <div className="branch-id">
                                <div className="branch-d">
                                  <div className="branch-name">
                                    <div className="text">{branch.BranchName}</div>
                                    <div className="code">{branch.BranchCode}</div>
                                  </div>
                                  <div
                                    //   data-value={branch.BranchID}
                                    onClick={() => handleShow(branch)}
                                    className="buttonedit"
                                  >
                                    { ( userRole=='admin' || userPermission?.includes(`w_${product}`) )&&<Link>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path
                                          d="M11.6176 1.74166L10.9381 1.06194C10.9345 1.05833 10.9307 1.05489 10.9269 1.05129L10.258 0.382384C9.74749 -0.127461 8.91746 -0.127461 8.40797 0.382384L0.778315 8.01203C0.737947 8.0524 0.710461 8.10393 0.699296 8.15994L0.0055033 11.6552C-0.0132203 11.7497 0.0164973 11.8475 0.0845221 11.9155C0.139148 11.9701 0.212841 12 0.288592 12C0.307316 12 0.32604 11.9981 0.344762 11.9947L3.83989 11.3011C3.89589 11.2897 3.94742 11.2624 3.98779 11.222L11.6179 3.59195C12.1279 3.08162 12.1277 2.25159 11.6177 1.74139L11.6176 1.74166ZM0.764151 10.7983L1.20201 11.236L0.655577 11.3444L0.764151 10.7983ZM3.64178 10.7519L1.88296 11.101L0.899549 10.1172L1.2486 8.35838L7.23931 2.36768L8.23182 3.36037L3.18482 8.40825C3.07213 8.52093 3.07213 8.70353 3.18482 8.81639C3.24116 8.87273 3.31502 8.9009 3.38889 8.9009C3.46275 8.9009 3.53662 8.87273 3.59296 8.81639L8.63952 3.76895L9.63204 4.76164L3.64178 10.7519ZM11.2099 3.18427L10.0406 4.35356L7.64737 1.95965L8.81631 0.790713C9.10112 0.505733 9.56508 0.505733 9.85025 0.790713L10.5301 1.47061C10.5338 1.47422 10.5375 1.47765 10.5413 1.48126L11.2099 2.14981C11.4948 2.43513 11.4948 2.8991 11.2099 3.18423L11.2099 3.18427Z"
                                          fill="#470377"
                                        />
                                      </svg>
                                    </Link>}
                                  </div>
                                </div>
                                <div className="branch-special">
                                  <div className="branch-btns">
                                    {/* <span className="special_rate">
                                                                          <svg
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width="13"
                                                                              height="9"
                                                                              viewBox="0 0 13 9"
                                                                              fill="none"
                                                                          >
                                                                              <path
                                                                                  d="M11.9991 1L4.97519 8L1 4.01288"
                                                                                  stroke="white"
                                                                                  stroke-width="1.3"
                                                                                  stroke-linecap="round"
                                                                              />
                                                                          </svg>
                                                                      </span> */}

                                    {branch?.calculationType?.toLowerCase() === 'percentage' && <PercentageSymbol />}
                                    {branch?.calculationType?.toLowerCase()?.includes('pais') && <RupeeSymbol />}
                                    <Link
                                      onClick={() => {
                                        handleDownloadClick(branch.BranchID);
                                      }}
                                      className="excelwise"
                                    >
                                      <img
                                        width="16"
                                        height="16"
                                        src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png"
                                        alt="external-Excel-logos-and-brands-those-icons-flat-those-icons"
                                      />
                                      &nbsp; Download
                                    </Link>
                                  </div>
                                  {branch?.rateUpdatedBy && (
                                    <div className="updatedby">
                                      <div className="update-tx">Updated By</div>
                                      <div className="update-name" title={branch?.rateUpdatedBy}>
                                        {showUserName(branch?.rateUpdatedBy)}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Nav.Link>
                          </Nav.Item>
                        );
                      })}
                    </Nav>
                  </Col>
                  <Col sm={9}>
                    <Tab.Content>
                      <Tab.Pane eventKey={currentBranch?.BranchName}>
                        {usertype !== 'user' && <Col sm={12} className="box-loc mb-3">
                          <Row>
                            <Col sm={4}>
                              {/* <Form.Label>Date</Form.Label>
                              <input type="date" className="form-control" placeholder="dd" /> */}
                            </Col>
                            <Col sm={8}>
                              {  (userRole=='admin'|| userPermission?.includes(`add_new_rate_${product}`)) &&
                              <Button
                                variant="outline-primary mrg-t30 float-end"
                                onClick={() => {
                                  PopulateMultipleBranchArray(allCurrencies);
                                  //console.log(isUsingExcel);
                                  //console.log(multiplebrancharray);
                                  setShowAddNewModal(true);
                                }}
                              >
                                {' '}
                                Add New Rate
                              </Button>}

                              {/*  */}
                              {/* <Button variant="outline-primary mrg-t30 float-end mrg-R15" onClick={downloadAllBranchData}><img
                                width="21" height="21"
                                src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png" alt="external-Excel-logos-and-brands-those-icons-flat-those-icons" /> Download Excel</Button> */}
                              {/*  */}
                            </Col>
                          </Row>
                        </Col>}
                        <Col sm={12} className="box-loc mb-3">
                          <Table responsive bordered>
                            <thead>
                              <tr>
                                <th>CN CODE</th>
                                <th>IBR</th>
                                <th>Customer Margin</th>
                                <th>Holiday Margin</th>
                                <th>Final Rate Margin</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentBranchData?.map((branchData) => {
                                return (
                                  <>
                                    {' '}
                                    <tr>
                                      <td rowSpan="2">{branchData.code}</td>
                                      <td rowSpan="2">{branchData.ask}</td>
                                      <td >Buy - {branchData.buy_margin}</td>
                                      <td>Buy - {branchData.holiday_buy_margin}</td>
                                      <td>
                                        Buy -{' '}
                                        {branchData.calculation_type === 'Paise'
                                          ? calcFinalRatePaise(branchData.ask, branchData.buy_margin, branchData.holiday_buy_margin, 'buy',branchData.code)
                                          : calcFinalRatePerc(branchData.ask, branchData.buy_margin, branchData.holiday_buy_margin, 'buy',branchData.code)}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Sell - {branchData.sell_margin}</td>
                                      <td>Sell - {branchData.holiday_sell_margin}</td>
                                      <td>
                                        Sell -{' '}
                                        {branchData.calculation_type === 'Paise'
                                          ? calcFinalRatePaise(
                                            branchData.ask,
                                            branchData.sell_margin,
                                            branchData.holiday_sell_margin,

                                            'sell',
                                            branchData.code
                                          )
                                          : calcFinalRatePerc(
                                            branchData.ask,
                                            branchData.sell_margin,
                                            branchData.holiday_sell_margin,
                                            'sell',
                                            branchData.code
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                            </tbody>
                          </Table>
                        </Col>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Tab>
          })}
        </Tabs>
      </Container>

      {/* Modal for editing */}
      <Modal
        show={show}
        onHide={() => {

          setIsUsingExcel(false);
          handleClose();

        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
      >
        {' '}
        {showLoader && <Loader />}
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">Update Rate(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col sm={12} className="mb-3">
            <Row>
              <Col sm={4}>
                <Form.Label>Branch</Form.Label>
                <input type="text" className="form-control" value={tempBranchId?.BranchName} disabled placeholder="Select Branch..." />
              </Col>
              <Col sm={3}>
                <Form>
                  <Form.Label>Margin Applied as</Form.Label>
                  {['radio'].map((type) => (
                    <div key={`inline-${type}`}>
                      <Form.Check
                        inline
                        label="Paise"
                        name="group1"
                        type={type}
                        value="Paise"
                        id={`inline-${type}-1`}
                        checked={selectedValue === 'Paise'}
                        onChange={(e) => {
                          handleRadioChange(e);
                        }}
                      />
                      <Form.Check
                        inline
                        label="Percentage"
                        name="group1"
                        type={type}
                        value="Percentage"
                        id={`inline-${type}-2`}
                        checked={selectedValue === 'Percentage'}
                        onChange={(e) => {
                          handleRadioChange(e);
                        }}
                      />
                    </div>
                  ))}
                </Form>
              </Col>
              <Col sm={2}>
                {/* <Button className="mrg-t30 float-end" onClick={() => { downloadExcel(currentBranchData) }}>Download Excel</Button> */}
                <Button
                  variant="outline-primary float-end"
                  className="mrg-t30 float-end"
                  onClick={() => {
                    downloadExcel(currentBranchData);
                  }}
                >
                  <img
                    width="21"
                    height="21"
                    src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png"
                    alt="external-Excel-logos-and-brands-those-icons-flat-those-icons"
                  />
                  &nbsp; Download{' '}
                </Button>
              </Col>
              <Col sm={3}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Import Excel</Form.Label>
                  <Form.Control
                    ref={fileInputRef}
                    type="file"
                    onClick={()=>{fileInputRef.current.value=null}}
                    onChange={(e) => {
                     
                      handleImportExcel(e);
                    }}
                  />
                </Form.Group>
                {/* <Button

                  variant="outline-primary mrg-t30 float-end"
                ><input type="file" onChange={(e) => { handleImportExcel(e) }}></input><img
                    width="21" height="21"
                    src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png" alt="external-Excel-logos-and-brands-those-icons-flat-those-icons" />


                </Button> */}
              </Col>
              {/* <Col sm={5}>

                <Button onClick={() => { downloadExcel(currentBranchData) }}>Download Excel</Button>

                
                <Button

                  variant="outline-primary mrg-t30 float-end"
                ><input type="file" ref={fileInputRef} onChange={(e) => { handleImportExcel(e) }}></input><img
                    width="21" height="21"
                    src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png" alt="external-Excel-logos-and-brands-those-icons-flat-those-icons" />


                </Button>


              </Col> */}
            </Row>
          </Col>
          <Col sm={12} id="res-scroll">
            <Table responsive bordered>
              <thead>
                <tr>
                  <th width="8%">Currency</th>
                  <th width="8%">IBR</th>
                  <th width="10%">{colNames[0]}</th>
                  <th width="12%">{colNames[1]}</th>
                  <th width="10%">Final Buy Margin</th>
                  <th width="10%">{colNames[2]}</th>
                  <th width="12%">{colNames[3]}</th>
                  <th width="10%">Final Sell Margin</th>
                </tr>
              </thead>
              <tbody> 
                {!isUsingExcel &&
                  currentBranchData?.map((currentbranch, index) => {
                    
                    return (

                      // <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={marginLimitPer} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                      <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={getMarginLimitPer(product)} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                    )

                  })
                }

                {isUsingExcel && excelData?.map((currentbranch, index) => {
                    return (
                      // <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={marginLimitPer} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                      <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={getMarginLimitPer(product)} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                    );
                  })}
              </tbody>
            </Table>

          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary float-end mrg-t0" onClick={handleSaveClicked}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Add new rate */}


      <Modal
        show={showAddNewModal}
        onHide={() => {
          setIsUsingExcel(false);
          setShowAddNewModal(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
      >
        {showLoader && <Loader />}

        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">Add New Rates ({Companies[companyValue]})</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col sm={12} className="mb-3">
            <Row>
              <Col sm={12} className="mb-3">
                <Multiselect
                  onSelect={(e, selectedItem) => {
                    handleBranchAdded(e, selectedItem);
                  }}
                  onRemove={(e, selectedItem) => {
                    handleBranchRemoved(e, selectedItem);
                  }}
                  selectionLimit={selectionLimit}
                  selectedValues={(e) => {
                    //console.log('Selected Values are :');
                    console.log(e);
                  }}
                  displayValue="name"
                  placeholder="Select Branches"
                  showArrow
                  options={branchNamesOptions}
                  isObject={true}
                >
                  <code className="displayBlock mt10">&lt;Multiselect</code>
                </Multiselect>
              </Col>
              <Col sm={6}>
                <Form>
                  <Form.Label>Margin Applied as</Form.Label>
                  {['radio'].map((type) => (
                    <div key={`inline-${type}`}>
                      <Form.Check
                        inline
                        label="Paise"
                        name="group1"
                        type={type}
                        value="Paise"
                        id={`inline-${type}-1`}
                        checked={selectedValue === 'Paise'}
                        onChange={(e) => {
                          handleRadioChange(e);
                        }}
                      />
                      <Form.Check
                        inline
                        label="Percentage"
                        name="group1"
                        type={type}
                        value="Percentage"
                        id={`inline-${type}-2`}
                        checked={selectedValue === 'Percentage'}
                        onChange={(e) => {
                          handleRadioChange(e);
                        }}
                      />
                    </div>
                  ))}
                </Form>
              </Col>
              <Col sm={3}>
                <Button
                  variant="outline-primary float-end"
                  className="mrg-t30 float-end"
                  onClick={() => {
                    downloadExcel(allCurrencies, true);
                  }}
                >
                  <img
                    width="21"
                    height="21"
                    src="https://img.icons8.com/external-those-icons-flat-those-icons/24/external-Excel-logos-and-brands-those-icons-flat-those-icons.png"
                    alt="external-Excel-logos-and-brands-those-icons-flat-those-icons"
                  />{' '}
                  Download Sample
                </Button>
              </Col>

              <Col sm={3}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Import Excel</Form.Label>
                  <Form.Control
                    ref={fileInputRef}
                    type="file"
                    onChange={(e) => {
                      handleImportExcel(e);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
          <Col sm={12} id="res-scroll">
            <Table responsive bordered>
              <thead>
                <tr>
                  <th width="8%">Currency</th>
                  <th width="8%">IBR</th>
                  <th width="10%">{colNames[0]}</th>
                  <th width="12%">{colNames[1]}</th>
                  <th width="10%">Final Buy Margin</th>
                  <th width="10%">{colNames[2]}</th>
                  <th width="12%">{colNames[3]}</th>
                  <th width="10%">Final Sell Margin</th>
                </tr>
              </thead>
              <tbody>
                {!isUsingExcel &&
                  multiplebrancharray?.map((currency, index) => {
                    return (

                      // <EditRateTable currentbranch={currency} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={marginLimitPer} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                      <EditRateTable currentbranch={currency} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={getMarginLimitPer(product)} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                    );
                  })}

                {isUsingExcel &&
                  excelData?.map((currentbranch, index) => {
                    return (


                      // <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={marginLimitPer} isWorkingTime={isNotHolidayTime(startTime, endTime)} />
                      <EditRateTable currentbranch={currentbranch} index={index} selectedValue={selectedValue} marginLimit={marginLimit} marginLimitPer={getMarginLimitPer(product)} isWorkingTime={isNotHolidayTime(startTime, endTime)} />

                    );
                  })}
              </tbody>
            </Table>

            {/* <Button variant="primary float-end mrg-t0" onClick={handleSaveClicked}>
              Save Changes
            </Button> */}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary float-end mrg-t0" onClick={saveMultipleBranchData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/*  */}


      
     
   
    </>
  );
};
export default RateAdmin;
